import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../store"
import { ChartComponent } from "./indicators/ChartComponent"
import PlaceholderWidget from "../../common/grid/widgets/PlaceholderWidget"
import SingleValueIndicator from "./indicators/SingleValueIndicator"
import { IIndicators } from "../index"

type StateProps = IIndicators

type Props = StateProps

export const IndicatorDetail = ({
    isLoading,
    indicatorDetail: { indicator },
}: Props): JSX.Element => (
    <>
        {!isLoading && (
            <div className="tw-w-1/2" data-ft-component="indicatorPreview">
                {indicator.hasChart ? (
                    <ChartComponent
                        chartData={indicator.chartData}
                        showLabels={indicator.showLabels}
                    />
                ) : (
                    <SingleValueIndicator
                        {...indicator}
                        isLink={false}
                        showLabel={false}
                        withPadding={false}
                    />
                )}
            </div>
        )}
        {isLoading && (
            <div className="tw-w-1/2 is-loading is-placeholder">
                <PlaceholderWidget />
            </div>
        )}
    </>
)

const mapStateToProps = (state: GlobalState): StateProps => state.indicators

export default connect(mapStateToProps, {})(IndicatorDetail)
